import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ScheduleSchema = withDefaults({
  type: 'schedule',
  fields: [
    {
      kind: 'attribute',
      name: 'ownerId',
    },
    {
      kind: 'attribute',
      name: 'ownerType',
    },
    {
      kind: 'attribute',
      name: 'scheduleType',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'startDate',
    },
    {
      kind: 'attribute',
      name: 'endDate',
    },
    {
      kind: 'attribute',
      name: 'intervalUnit',
    },
    {
      kind: 'attribute',
      name: 'intervalValue',
    },
    {
      kind: 'attribute',
      name: 'dateUnit',
    },
    {
      kind: 'attribute',
      name: 'dateValues',
    },
    {
      kind: 'attribute',
      name: 'config',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'nextEventDate',
    },
    {
      kind: 'attribute',
      name: 'dayOfWeek',
    },
    {
      kind: 'attribute',
      name: 'endOfYearCutoff',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'belongsTo',
      name: 'owner',
      type: 'owner',
      options: {
        async: false,
        polymorphic: true,
        inverse: 'schedules',
      },
    },
  ],
});

export default ScheduleSchema;
